import { generateRandomID } from "helpers/generateRandomID"
import { xlsxTypes } from "./gasMovDataXLSXTypes"

const { SET_XLSX, SET_XML, SET_ALL_XML_STATUS, RESET_XLSX_STATE } = xlsxTypes

const initialState = {
  xlsx: [],
  xml: []
}
export const gasMovDataXLSXReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_XLSX:
      return {
        ...state,
        xlsx: [
          ...state.xlsx,
          payload
        ],
      }

    case SET_XML:
      return {
        ...state,
        xml: [
          ...state.xml,
          {
            id: generateRandomID(6),
            status: 'UPLOAD',
            fileName: payload?.name,
            file: payload
          }
        ],
      }
        
    case SET_ALL_XML_STATUS:
      return {
        ...state,
        xml: payload
      }

    case RESET_XLSX_STATE:
      return initialState

    default:
      return state;
  }
}